export const USER_REQUESTS_HEADERS_PENDING = [
  {
    key: 'name',
    label: 'File name',
    type: 'string',
  },
  {
    key: 'review',
    label: 'View file',
    type: 'review',
  },
  {
    key: 'createdAt',
    label: 'Request date',
    type: 'date',
  },
  {
    key: 'internalComment',
    label: 'Internal Comment',
    type: 'internalComment',
  },
  {
    key: 'status',
    label: 'Actions',
    type: 'actions',
  },
]

export const USER_REQUESTS_HEADERS_HISTORY = [
  {
    key: 'name',
    label: 'File name',
    type: 'string',
  },
  {
    key: 'review',
    label: 'View File',
    type: 'review',
  },
  {
    key: 'updatedAt',
    label: 'Updated on',
    type: 'date',
  },
  {
    key: 'editedBy',
    label: 'User',
    type: 'string',
  },
  {
    key: 'comment',
    label: 'Rejection Reasons',
    type: 'comment',
  },
  {
    key: 'status',
    label: 'Status',
    type: 'actions',
  },
]

export const VIEW_TYPES = {
  PENDING: 'PENDING',
  HISTORY: 'HISTORY',
}
